import { Action } from '@ngrx/store';
import { CardRefresh } from '../../model/ngrx/card-refresh.model';
import * as CardRefreshActions from './../actions/card-refresh.actions';

export type Actions = CardRefreshActions.Actions;

const initialState: CardRefresh = {
    setCardRefresh: true
   
};

// const newState = (state, newData) => {
//     return Object.assign({}, state, newData);
// };

export function cardRefreshReducer(state: CardRefresh[] = [initialState], action: CardRefreshActions.Actions) {
    switch (action.type) {
        case CardRefreshActions.ADD_CARD_REFRESH:
            return [...state, action.payload];
        // return newState(state, { quoteReferenceNumber: action.payload });

        // Add this case:
        case CardRefreshActions.REMOVE_CARD_REFRESH:
            state = []; // [...state].splice(action.payload, 1);
            return state;

        default:
            return state;
    }
}